/* eslint-disable @stylistic/array-element-newline */
/* eslint-disable @stylistic/array-bracket-newline */

import { datadogRum, RumEvent } from '@datadog/browser-rum';

import { toCamelCase } from './string';

export const datadogKnownErrorIgnorelists = {
  adobe: [
    'Failed to load script https://assets.adobedtm.com',
  ],
  crossOriginScript: [
    'Script error.',
  ],
  hotJar: [
    "Can't find variable: hj",
    'hj is not defined',
  ],
  liveRamp: [
    "undefined is not an object (evaluating 'e.country')",
  ],
  osano: [
    // This is coming from react-dom-client but is often caused by Osano
    "Failed to execute 'removeChild' on 'Node'",
  ],
  uselessStackTrace: [
    'The object can not be found here.', // Same place in react-dom-client that the Osano "removeChild" error is coming from.
    'Uncaught {"isTrusted":true}',
  ],
};

export const beforeSend = (event: RumEvent) => {
  if (event.type !== 'error') { return true; }

  // Discard known 3rd party errors
  return Object.entries(datadogKnownErrorIgnorelists).every(([key, errorMessages]) => {
    if (errorMessages.some((msg) => event.error?.message?.includes(msg))) {
      datadogRum.addAction(`caughtError.${key}`, { eventError: event.error });

      return false;
    }

    return true;
  });
};

export const normalizeTrackedAction = (pathname: string): string => {
  return toCamelCase(pathname.replace(/^\//, ''));
};

export const datadogRumErrorHandling = {
  onCaughtError: (error: unknown, errorInfo: { componentStack?: string; }) => {
    datadogRum.addError(error, {
      componentStack: errorInfo?.componentStack,
      reactErrorHandler: 'onCaughtError',
    });
  },
  onRecoverableError: (error: unknown, errorInfo: { componentStack?: string; }) => {
    datadogRum.addError(error, {
      componentStack: errorInfo?.componentStack,
      reactErrorHandler: 'onRecoverableError',
    });
  },
  onUncaughtError: (error: unknown, errorInfo: { componentStack?: string; }) => {
    datadogRum.addError(error, {
      componentStack: errorInfo?.componentStack,
      reactErrorHandler: 'onUncaughtError',
    });
  },
};
